import axios from 'axios';
import { store } from '../Redux/store';
import { logout } from '../Redux/authSlice';
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

export const AxiosClient = axios.create({
  baseURL: process.env.REACT_APP_SERVER_BASE__URL,
  timeout: 0,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add Authorization header if token exists
AxiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['authorization'] = `${token}`;
  }
  return config;
});

AxiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch(logout());
      history.push('/eccta-compliance/login');
    }
    return Promise.reject(error);
  }
);
